<script>
import RCheckbox from './RCheckbox.vue'
import { fileDataManage } from '@/observable'
export default {
	name: 'FolderAndResourceElement',
  components: {
    RCheckbox
  },
	props: {
		item: {
			type: Object,
			required: true
    },
    enterEditorMode: {
      type: Boolean,
      default: false
    }
	},
  computed: {
		fileDataManage() {
			return fileDataManage
		}
	},
  methods: {
    showImage(file) {
      return file.is_folder === 1 ? require('@/assets/image/folderImg.png')
        : file.file_type == 1
        ? file?.path?.url
        : file.file_type == 3
        ? require('@/assets/image/videoImg.png')
        : require('@/assets/image/audioImg.png')
    },
    isChecked(item) {
			return this.fileDataManage.checkedList.some(x => x.id === item.id)
    },
    /**
     * 选中文件或文件夹
     * @param check 是否选中
     * @param item 文件或文件夹
     */
    changeSelect(check, item) {
      console.log(item, this.fileDataManage, '赋值')
			if (check) {
				this.fileDataManage.checkedList.push(item)
			} else {
				this.fileDataManage.checkedList = this.fileDataManage.checkedList.filter(x => x.id !== item.id)
			}
		}
  }
}
</script>

<template>
	<div class="folderElement" @click="$emit('resourceClick', item)">
    <RCheckbox
      v-if="!item.is_folder || enterEditorMode"
      class="checkBtn"
      :checkStatus="isChecked(item)"
      @statusChange="e => changeSelect(e, item)"
    />
    <el-tooltip :content="item.title || item.origin_filename">
      <div class="folderElementCtx">
        <div class="imgBox">
          <img v-if="item.is_folder === 1" :src="require('@/assets/image/folderImg.png')" :alt="item.title" />
          <template v-else>
            <img v-if="item.file_type === 1" :src="item?.path?.url || ''" :alt="item.title" />
            <img v-if="item.file_type === 3" :src="require('@/assets/image/videoImg.png')" :alt="item.title" />
            <img v-if="item.file_type === 2" :src="require('@/assets/image/audioImg.png')" :alt="item.title" />
          </template>
        </div>
        <span class="title">{{item.title || item.origin_filename}}</span>
      </div>
    </el-tooltip>
	</div>
</template>

<style scoped lang="scss">
.folderElement{
  position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	float: left;
	margin-right: 50px;
	cursor: pointer;
  .checkBtn {
    position: absolute;
    z-index: 1;
    top: -10px;
    right: -10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
  .folderElementCtx{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .imgBox{
      width: 130px;
      height: 100px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      user-select: none;
      img{
        max-width: 100%;
        max-height: 100%;
      }
    }
    .title{
      height: 40px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 140px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.folderElement:nth-child(5n){
  margin-right: 0;
}

.folderElement:nth-child(-n+5){
  margin-top: 10px;
}

</style>
